import { store } from "@/setup/store";

const urlParams = new URLSearchParams(window.location.search)
const lang = urlParams.get('lang') || null

if ( lang ) {
  store.commit('setLang', lang)
}
